module.exports = __webpack_public_path__ + "img/Consulting-rafiki.7389ca7f.svg";